module.exports = __webpack_public_path__ + "static/media/logo-uongbi.dda80622.png";